import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../../helpers/string-helper';

@Pipe({
  name: 'atelierNameDate',
})
export class AtelierNameDatePipe implements PipeTransform {
  transform(name: string, date: string) {
    return StringHelper.join([name, date], ' - ');
  }
}
